import React, { useState, useContext, useEffect } from "react";
import { TaskContext } from "../components/TaskContext";
import { marginBottom } from "../App";
import { UserDataContext } from "../components/UserDataContext";
import TaskChatStory from "./TaskChatStory";
import Alerts from "../components/Alerts";
import { apiRequest } from "../components/Config";
import TaskChatForm from "./TaskChatForm";
import TaskChatFormPzitb from "./TaskChatFormPzitb";
import TaskChatFormReporter from "./TaskChatFormReporter";
import { Row, Col } from "react-bootstrap";
import Button from "@mui/material/Button";

export default function TaskChat() {
  const { taskId } = useContext(TaskContext);
  const { userData } = useContext(UserDataContext);
  const [performer, setPerformer] = useState(null);
  const [performerId, setPerformerId] = useState(null);
  const [reporterMail, setReporterMail] = useState(null);
  const [title, setTitle] = useState("");
  const [author, setAuthor] = useState("");
  const [content, setContent] = useState("");
  const [pzitb, setPzitb] = useState(0);
  const [type, setType] = useState(0);
  const [error, setError] = useState("");
  const [insertId, setInsertId] = useState("");
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [apiResponse, setApiResponse] = useState({});
  const [show, setShow] = useState(false);
  const [showReporter, setShowReporter] = useState(false);
  const [showPerformer, setShowPerformer] = useState(false);
  const [activeForm, setActiveForm] = useState("performer");

  const handleContentChange = (event) => {
    const value = event.target.value;
    setContent(value);
    setError(
      value.length > 2000
        ? "Treść zlecenia nie może przekraczać 2000 znaków."
        : "",
    );
  };

  const handleTitleChange = (event) => {
    const value = event.target.value;
    setTitle(value);
    setError(value.length < 1 ? "Nie podano tematu korespondencji." : "");
  };

  const handleAuthorChange = (event) => {
    const value = event.target.value;
    setAuthor(value);
    setError(value.length < 1 ? "Nie podano autora korespondencji." : "");
  };

  const handleSubmit = async () => {
    const values = {
      taskId,
      title,
      content,
      author,
      pzitb,
      reporterMail,
    };

    if (type === 0) {
      values.reporterMail = null;
    }
    //console.log("Values : ", values);
    if (pzitb === 1 && author.length === 0) {
      setShowApiResponse(true);
      setApiResponse({
        title: "Błąd",
        severity: "warning",
        info: "Brak autora maila!",
      });
      return;
    } else {
      setShowApiResponse(false);
    }
    if (title.length === 0 || content.length === 0) {
      setShowApiResponse(true);
      setApiResponse({
        title: "Błąd",
        severity: "warning",
        info: "Brak tematu lub treści!",
      });
      return;
    } else {
      setShowApiResponse(false);
    }

    try {
      //console.log("Values: ", values);
      const response = await apiRequest("newmail", "POST", values);

      console.log("mail response: ", response);
      if (response.error_msg === "sent") {
        setInsertId(response.lastInsertId);
        setShowApiResponse(true);
        setApiResponse({
          title: "Sukces",
          severity: "success",
          info: "Wiadomość wysłana!",
        });
        setTitle("");
        setContent("");
        setAuthor("");
      }
    } catch (error) {
      console.error("Błąd: ", error);
    }
  };

  useEffect(() => {
    if (userData) {
      //console.log("UserData: ", userData);
      const fetchData = async () => {
        try {
          const response = await apiRequest(`taskPerformer/${taskId}`, "GET");
          //console.log("taskData: ", response[0]);
          setPerformer(response[0].performer);
        } catch (error) {
          console.error(error.message);
        }
      };
      fetchData();
    }
  }, [userData, taskId]);

  const handleShow = () => {
    setType(0);
    setShow(!show);

    if (show) {
      setPzitb(0);
    }
    if (!show) {
      setPzitb(1);
    }
  };

  const handleShowPzitb = () => {
    setActiveForm("pzitb");
    setType(0);
    setPzitb(1);
  };

  const handleShowPerformer = () => {
    setActiveForm("performer");
    setType(0);
    setPzitb(0);
  };
  const handleShowReporter = () => {
    setActiveForm("reporter");
    setType(1);
    setPzitb(0);
  };
  /*
  const handleShowPerformer = () => {
    setShowPerformer(!showPerformer);
    console.log("showPerformer: ", showPerformer);
  };

  const handleShowReporter = () => {
    setShowReporter(!showReporter);
    setType(1);
  };
*/
  useEffect(() => {
    console.log("TYPE: ", type);
  }, [type]);

  useEffect(() => {
    const fetchData = async () => {
      if (!userData || !userData.userId) return;
      try {
        const response = await apiRequest("task/" + taskId, "GET");
        console.log("taskData: ", response[0]);
        setPerformerId(response[0].performer);
        setReporterMail(response[0].reporterMail);
      } catch (error) {
        console.error("Błąd pobierania danych", error);
      }
    };
    fetchData();
  }, [userData, taskId]);

  /*
  useEffect(() => {
    if (userData) {
      console.log("handleShow PZITB mail", pzitb);
    }
  }, [show]);
*/
  return (
    <div>
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      {(userData.permId === "1" || userData.permId === "3") && (
        <Row style={{ marginBottom }}>
          <Col>
            <Button
              type="button"
              variant={activeForm === "performer" ? "contained" : "outlined"}
              color="info"
              onClick={handleShowPerformer}
            >
              Korespondencja: Wykonawca
            </Button>
          </Col>
          <Col>
            <Button
              variant={activeForm === "pzitb" ? "contained" : "outlined"}
              color="success"
              onClick={handleShowPzitb}
            >
              Korespondencja: PZITB
            </Button>
          </Col>
          <Col>
            <Button
              variant={activeForm === "reporter" ? "contained" : "outlined"}
              color="warning"
              onClick={handleShowReporter}
            >
              Korespondencja: Zleceniodawca
            </Button>
          </Col>
        </Row>
      )}
      <div className="form-container">
        {activeForm === "pzitb" && userData && (
          <TaskChatFormPzitb
            userData={userData}
            title={title}
            content={content}
            error={error}
            handleTitleChange={handleTitleChange}
            handleContentChange={handleContentChange}
            handleAuthorChange={handleAuthorChange}
            handleSubmit={handleSubmit}
          />
        )}

        {activeForm === "reporter" && userData && (
          <TaskChatFormReporter
            userData={userData}
            title={title}
            content={content}
            reporter={reporterMail}
            error={error}
            handleTitleChange={handleTitleChange}
            handleContentChange={handleContentChange}
            handleAuthorChange={handleAuthorChange}
            handleSubmit={handleSubmit}
          />
        )}

        {activeForm === "performer" && userData && (
          <>
            {performer !== null ? (
              <TaskChatForm
                userData={userData}
                title={title}
                content={content}
                error={error}
                handleTitleChange={handleTitleChange}
                handleContentChange={handleContentChange}
                handleSubmit={handleSubmit}
              />
            ) : (
              <p className="p5">
                Utworzenie korespondencji jest możliwe po przydzieleniu
                Wykonawcy.
              </p>
            )}
          </>
        )}
      </div>
      <TaskChatStory insertId={insertId} />
    </div>
  );
}
